import { render } from "./WsSearch.vue?vue&type=template&id=9ca0174c"
import script from "./WsSearch.vue?vue&type=script&lang=js"
export * from "./WsSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__